module.exports = __webpack_public_path__ + "fonts/LidlFontCondPro-Bold.woff2";